import React, { useState, useEffect } from 'react'
import './new.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import {serverTimestamp, setDoc, doc, addDoc, collection } from "firebase/firestore";
import { auth, db, } from "../../../firebase";
import { createUserWithEmailAndPassword } from 'firebase/auth';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom"
import { Password } from '@mui/icons-material';
import { getFunctions, httpsCallable } from "firebase/functions";
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { functions } from '../../../firebase';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';


const roles = [

  { label: 'Admin', value: 'adminAccess' },

  { label: 'Sub Admin', value: 'subadminAccess' },


];

const date = new Date().toDateString()

const New = ({inputs, title}) => {

  const [file, setFile ] = useState("")
  const [firstname, setFirstname] = useState("")
  const [lastname, setLastname] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [confirmpassword, setConfirmpassword] = useState("")
  const [telephone, setTelephone] = useState("")
  const [role, setRole] = useState("")
  const [status, setStatus] = useState("inactive")
  const [data, setData ] = useState({})
  const [perc, setPerc ] = useState(null)
  const [message, setMessage] = useState('')
  const [firstnameerror, setFirstnameerror] = useState("")
  const [lastnameerror, setLastnameerror] = useState("")
  const [emailerror, setEmailerror] = useState("")
  const [passworderror, setPassworderror] = useState("")
  const [confirmpassworderror, setConfirmpassworderror] = useState("")
  const [roleerror, setRoleerror] = useState("")
  const [telephoneerror, setTelephoneerror] = useState("")
  const [error, setError] = useState(false)
  const [firebaseError, setFirebaseError] = useState(false)

  const [showPassword, setShowPassword] = useState(false);

  
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  
  const [isloading, setIsloading] = useState(false)

  const [adminId, setAdminId] = useState("")

  
  const navigate = useNavigate();


  const handleRoleChange = (e) => {

    setRole(e.target.value);
 
  };

  const Spinner = () => {
  return(
    <span className='spinner-container'>
        <span className='loading-spinner'></span>
    </span>
  )
  }


  const handleToggle = () => {

    setShowPassword((prev) => !prev);

  };


   const handleToggleConfirm = () => {

    setShowConfirmPassword((prev) => !prev);

  };



  const handleAdd = async (e) => {


    e.preventDefault();

     if(email === "") {
      
      return setEmailerror('Email is required')
      
    }

     if(password === "") {
      return setPassworderror('Password is required')
      
    }

    if(confirmpassword === "") {
      return setConfirmpassworderror('Confirm Password is required')
      
    }

    if(password !== confirmpassword){
      return setConfirmpassworderror('Password and confirm Password must be the same')
      
    }

    if(firstname === "") {

      return setFirstnameerror('firstname is required')
      
    }

    if(lastname === "") {

      return setLastnameerror('lastname is required')
    
    }

    if(telephone === "") {

      return setTelephoneerror('lastname is required')
    
    }

    if(role === "") {

      return setRoleerror('role is required')
      
    }

    setIsloading(true);
    
    // setMessage('');

    try {
     
      // Reference our backend Cloud Function
      const getOrCreateAdminFn = httpsCallable(functions, 'getOrCreateAdmins');
      
      // Execute function with the form data
      const result = await getOrCreateAdminFn({ email, password, firstname, lastname, telephone, role, status  });
      
      setMessage(`Success: ${result.data.message}`);

      setEmail('');
      setPassword('');
      setFirstname("");
      setLastname("");
      setConfirmpassword("");
      setTelephone("");
      setRole("");

      alert(result.data.message)

      navigate('/settings')


    } catch (error) {

      console.error(error);
      
      setMessage(`Error: ${error.message}`);

    } finally {

      setIsloading(false);

    }

  };



  return (
    <div className="new">
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
          <div className='topLeft'><h1>New Chillaxia Admin</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/settings"
            >
              Admin List
            </Link>
            <Typography color="green">New Admin</Typography>
          </Breadcrumbs>
          </div>
        </div>
         <div>
              <span>{message}</span>
            </div>
        <div className='top'>
         
           
            <div className="left">

              
               {/* <span style={{color:'red', fontSize:14}}>{error && 'Email already exist'}</span> */}

              {
                
                firebaseError &&

                <span style={{color:'red', fontSize:18}}>{firebaseError}</span>

              }

               {/* <span style={{color:'red', fontSize:14}}>{error && 'Email already exist'}</span> */}

               

            <div className='form'  >
            {/* <div className='formInput' > */}


               
                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:20}}>

                  <TextField
                    id="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    value = {email}
                    placeholder="Enter Email"
                    type="email"
                    style={{width:'100%'}}
                  />

                  {emailerror &&
                  <p style={{color:'red', fontSize:10, marginVertical:5}}> {emailerror}</p>
                  }
            

                  </div>

               
                <div style={{display: 'flex', position:'relative', flexDirection:'column', gap:10, width:'49%', marginBottom:20}}>

                <TextField
                  id="password"
                  onChange={(e) => setPassword(e.target.value)}
                  value = {password}
                  placeholder="Enter Password"
                  style={{width:'100%'}}
                  // type="password"
                  type = {showPassword ? 'text' : 'password'}
                />

                <button
                  type="button"
                  onClick={handleToggle}
                  style={{
                    position: 'absolute',
                    right: '20px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer'
                  }}
                >
                  {showPassword ? 

                    <VisibilityIcon size={8}/>
                  : 

                    <VisibilityOffIcon size={8}/>
                  
                  }
                </button>

                {passworderror &&
                <p style={{color:'red', fontSize:10, marginVertical:5}}> {passworderror}</p>
                }

                </div>

                <div style={{display: 'flex', position:'relative', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:20}}>

                  <TextField
                  id="confirmpassword"
                  onChange={(e) => setConfirmpassword(e.target.value)}
                  value = {confirmpassword}
                  placeholder="Re-enter Password"
                  style={{width:'100%'}}
                  // type="password"
                  type = {showConfirmPassword ? 'text' : 'password'}
                />

                 <button
                  type="button"
                  onClick={handleToggleConfirm}
                  style={{
                    position: 'absolute',
                    right: '20px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer'
                  }}
                >
                  {showConfirmPassword ? 

                    <VisibilityIcon size={8}/>
                  : 

                    <VisibilityOffIcon size={8}/>
                  
                  }
                </button>


                {confirmpassworderror &&
                <p style={{color:'red', fontSize:10, marginVertical:5}}> {confirmpassworderror}</p>
                }

                </div>
             
                <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20}}>

                <TextField
                  id="firstname"
                  onChange={(e) => setFirstname(e.target.value)}
                  value = {firstname}
                  placeholder="Enter Firstname"
                  style={{width:'100%'}}
                />

                {firstnameerror &&
                <p style={{color:'red', fontSize:10, marginVertical:5}}> {firstnameerror}</p>
                }

                </div>
       
               <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:20}}>

                <TextField
                  id="lastname"
                  onChange={(e) => setLastname(e.target.value)}
                  value = {lastname}
                  placeholder="Enter Lastname"
                  style={{width:'100%'}}
                />

                {lastnameerror &&
                <p style={{color:'red', fontSize:10, marginVertical:5}}> {lastnameerror}</p>
                }

               </div>
             
              
              <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20}}>

                  <TextField
                  id="telephone"
                  onChange={(e) => setTelephone(e.target.value)}
                  value = {telephone}
                  placeholder="+2348139444402"
                  style={{width:'100%'}}
                />

                  {telephoneerror &&
                  <p style={{color:'red', fontSize:10, marginVertical:5}}> {telephoneerror}</p>
                  }


              </div>

         
              <div style={{display: 'flex', flexDirection:'column', gap:10, width:'49%', marginBottom:20, marginRight:20}}>

              <Box sx={{ minWidth: '100%' }}>
              <FormControl fullWidth>
              <InputLabel id="role" style={{color:'#999', fontWeight:300}}>Select Your Outlet Role</InputLabel>
              <Select
                labelId="role"
                id="role"
                value={role}
                label="role"
                onChange={(e) => setRole(e.target.value)}
          
              >

          

            {roles.map((item) => { 

                return(

                  <MenuItem key={item.id} value={item.value}>
                  
                      {item.label}
                 
                  </MenuItem>

                ) 
              })} 

            </Select>
            </FormControl>
            </Box>

               <span style={{color:'red', fontSize:10}}>{roleerror && roleerror}</span>
              </div>

          

                <Button 
                onClick={handleAdd}
                // disabled={perc !== null && perc < 100}
                style={{width:'100%', backgroundColor:'rgb(15, 31, 175)', paddingTop:10, paddingBottom:10, color:'white'}}>{isloading ? "...Loading": 'Add Admin'}
                </Button>
            </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default New














// src/components/AdminCreator.jsx
// import React, { useState } from 'react';
// import { initializeApp } from 'firebase/app';
// import { getFunctions, httpsCallable } from 'firebase/functions';
// import {functions} from '../../../firebase'

// // const firebaseConfig = { /* Your Config Here */ };
// // const app = initializeApp(firebaseConfig);
// // const functions = getFunctions();

// export default function New() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [age, setAge] = useState('');
//   const [telephone, setTelephone] = useState('');
//   const [gender, setGender] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState('');

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage('');

//     try {
//       const getOrCreateAdminFn = httpsCallable(functions, 'getOrCreateAdmins');
      
//       // Pass the extra profile variables directly into the payload object
//       const result = await getOrCreateAdminFn({ 
//         email, 
//         password, 
//         age, 
//         telephone, 
//         gender 
//       });
      
//       setMessage(`Success: ${result.data.message}`);
//       // Clear all fields on success
//       setEmail(''); setPassword(''); setAge(''); setTelephone(''); setGender('');
//     } catch (error) {
//       setMessage(`Error: ${error.message}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={{ maxWidth: '400px', margin: '2rem auto', padding: '1rem', border: '1px solid #ccc' }}>
//       <h2>Create or Upgrade Admin Account</h2>
//       <form onSubmit={handleSubmit}>
//         <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required style={{width:'100%', marginBottom:'0.5rem'}} />
//         <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required style={{width:'100%', marginBottom:'0.5rem'}} />
//         <input type="number" placeholder="Age" value={age} onChange={e => setAge(e.target.value)} style={{width:'100%', marginBottom:'0.5rem'}} />
//         <input type="tel" placeholder="Telephone" value={telephone} onChange={e => setTelephone(e.target.value)} style={{width:'100%', marginBottom:'0.5rem'}} />
        
//         <select value={gender} onChange={e => setGender(e.target.value)} style={{width:'100%', marginBottom:'1rem', padding:'0.25rem'}}>
//           <option value="">Select Gender</option>
//           <option value="male">Male</option>
//           <option value="female">Female</option>
//           <option value="other">Other</option>
//         </select>

//         <button type="submit" disabled={loading}>{loading ? 'Processing...' : 'Submit Profile'}</button>
//       </form>
//       {message && <p>{message}</p>}
//     </div>
//   );
// }
